// Role const
export const ADMIN = "Admin";
export const USER = "User";
export const KID = "Kid";
